import React, { useEffect, useState } from 'react';

import { useTheme } from '../Contexts/ThemeContext';

import { getTranslatedValue } from '../Utils/getTranslatedText';

import FooterMenu from '../Components/Footer/FooterMenu';
import IFrameSource from '../Components/IFrameSource';

const IframePage = ({ data, language, isInternalLanguageChange }) => {
    const { setTheme } = useTheme();

    const [localizedIframeSrc, setLocalizedIframeSrc] = useState(
        () => getTranslatedValue(data?.iframeSrc ?? null, language)
    );
    
    useEffect(() => {
        setTheme('');
    }, [setTheme]);

    useEffect(() => {
        if (isInternalLanguageChange) {
            setLocalizedIframeSrc(getTranslatedValue(data?.iframeSrc ?? null, language));
        }
    }, [language, isInternalLanguageChange, data]);

    if (!localizedIframeSrc) {
        return null;
    }

    const iframeTitle = data?.theme ?? 'none'
    
    return (
        <>
            <div className="iframe-page">
                <IFrameSource 
                    title={iframeTitle || ""} 
                    src={localizedIframeSrc || ''}
                />
            </div>
            <FooterMenu />
        </>
    );
}

export default IframePage;